import { Seo } from "@/components/specific/seo/Seo";
import LoginForm from "./components/LoginForm";
import PageWrap from "@/components/layout/containers/PageWrap";

export default function LoginPage() {
    return (
    <>
      <Seo title="Logowanie" />
      <PageWrap className="shadow-form bg-gray-50">
        <div className="w-full rounded-3xl">
          <LoginForm />
        </div>
      </PageWrap>
      </>
    )
  }